export enum ELocale {
  EN_US = 'en-US',
  DE_DE = 'de-DE',
  EN_GB = 'en-GB',
  FR_FR = 'fr-FR',
  IT_IT = 'it-IT',
  PL_PL = 'pl-PL',
  CS_CZ = 'cs-CZ',
  SK_SK = 'sk-SK',
  NL_NL = 'nl-NL',
  NN_NO = 'nn-NO',
  ES_ES = 'es-ES',
  SV_SE = 'sv-SE',
  DA_DK = 'da-DK',
}

export const EULocales: Set<ELocale> = new Set([
  ELocale.DE_DE,
  ELocale.EN_GB,
  ELocale.FR_FR,
  ELocale.IT_IT,
  ELocale.PL_PL,
  ELocale.CS_CZ,
  ELocale.SK_SK,
  ELocale.NL_NL,
  ELocale.NN_NO,
  ELocale.ES_ES,
  ELocale.SV_SE,
  ELocale.DA_DK,
]);
